const getDateErrorText = (error, invalidDateText = "Λανθασμένη ημερομηνία") => {
  // This function is supposed to help with the improvment
  // of yup error messages, which are not user friendly (especially
  // localized)
  // In the default case, the original error is shown as a last resort

  switch (error) {
    case "dt_birth_afora must be a `date` type, but the final value was: `Invalid Date` (cast from the value `[Function anonymous]`).":
      return invalidDateText;
    case "dt_birth_afora must be a `date` type, but the final value was: `Invalid Date` (cast from the value `Invalid Date`).":
      return invalidDateText;
    default:
      return error;
  }
};

export default getDateErrorText;
